import { DeclarationPropertyData } from "./declarationPropertyData";
import { Dictionary } from "./types/index";

/**  Данные по декларации операции. */
export class DeclarationData {
  /**ИД каталога. */
  public Id: number = 0;
  /**Признак активности. */
  public IsActive: boolean = false;
  /**Заголовок. */
  public Caption: string = "";
  /**Ниезменяемый в последующем заголовок. */
  public CaptionDeclaration: string = "";
  /**Описание. */
  public Description: string = "";
  /**Реквизиты операции. */
  public Properties: Array<DeclarationPropertyData> = [];

  /**
   * Конструктор с загрузкой данных из ответа сервера.
   * @param src данные с сервера
   */
  constructor(catalogId: number = 0, src: any = null, codeOfByCard: string = "", codeOfToExt: string = "") {
    if (src) {
      this.Id = catalogId;

      this.IsActive = src.IsActive ?? false;

      const sXml: string = src.Value ?? "";
      if (sXml.trim() === "") {
        this.IsActive = false;
        return;
      }

      // Парсим XML.
      const parser = new DOMParser();
      const xDoc = parser.parseFromString(sXml, "text/xml");

      xDoc.getElementsByTagName("respondent")[0].childNodes[0].nodeValue;
      const xResp = xDoc.getElementsByTagName("respondent")[0]; //("R:respondent", xnm)
      this.Caption = xResp.getAttribute("caption") ?? "";
      this.CaptionDeclaration = xResp.getAttribute("caption") ?? "";
      // XmlNamespaceManager xnm = new XmlNamespaceManager(xDoc.NameTable)
      // xnm.AddNamespace("R", @"urn:respondent-schema")

      // Заполняем описания.
      const dPropsDescr: Dictionary<string> = {};
      const xnDescr = xResp.getElementsByTagName("description")[0];
      if (xnDescr != null) {
        this.Description =
          xnDescr.getElementsByTagName("common")[0].innerHTML ?? "";
        const xlDescrProps = xnDescr.getElementsByTagName("properties")[0];
        if (xlDescrProps != null) {
          const descrProperties = xlDescrProps.getElementsByTagName("property");

          for (let i = 0; i < descrProperties.length; i++) {
            const sKey = descrProperties[i].getAttribute("name") ?? "";
            const sVal = descrProperties[i].innerHTML;
            dPropsDescr[sKey] = sVal;
          }
        }
      }
      // Заполняем список пропертей.
      const xpList = xResp.getElementsByTagName("property");
      for (let i = 0; i < xpList.length; i++) {
        if (xpList[i].parentElement?.tagName !== xResp.tagName) continue;

        const dpd = new DeclarationPropertyData(xpList[i], dPropsDescr, catalogId == parseInt(codeOfByCard), catalogId == parseInt(codeOfToExt));

        this.Properties.push(dpd);
      }
    }
  }
}
